import React from "react";
import { clsx } from "clsx";
import { Loader } from "@/components/ui/loader";

interface Props {
  order: number;
  processing: boolean;
  isEdit: boolean;
  hasContent: boolean;
}

export const OrderBadge: React.FC<Props> = ({ order, processing, isEdit, hasContent }) => (
  <div
    className={clsx(
      "flex size-8 flex-shrink-0 items-center justify-center rounded-md text-sm font-semibold transition-colors",
      {
        "bg-coral/15 text-coral": processing,
        "bg-[#f1e2ce] text-desert-sand-700": !processing && hasContent && !isEdit,
        "bg-coral/20 text-coral": isEdit,
        "bg-[#f7f2ec] text-gray-500": !hasContent,
      },
    )}
  >
    {processing ? <Loader className="h-3.5 w-3.5" /> : <span>{order + 1}</span>}
  </div>
);
